import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import { savePDF } from "@progress/kendo-react-pdf";
import PageTemplate from "Routes/pdfTemplate";

import Moment from 'moment';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';



import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import {  
    allInjuryprofile,
    fetchInjuryAllProfile
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


class injuryprofilereport extends Component {
   
    constructor(props) {
      
        super(props);
            this.nodeRef = React.createRef();
            this.state = {
                viewdiv:true,
                succdiv:false,
                student:'',
                studentName:'',
                heightProportion: 3500,
                widthProportion: 1200
            };  
        
      
        this.onBackSection = this.onBackSection.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
      
    }

    UNSAFE_componentWillMount() {
        this.props.allInjuryprofile();
        
	}
    
    updateDimensions() {
        if (!this.nodeRef || !this.nodeRef.current) return;
        const node = this.nodeRef.current;
        const nodewidth = node.offsetWidth;
        let totalHeight = 0;
        const slides = node.querySelectorAll('.testclass');
        slides.forEach((slide) => {
            totalHeight += slide.scrollHeight;
        });
        const minHeight = window.innerHeight;
        const heightProportion = totalHeight > minHeight ? totalHeight : minHeight;

        this.setState({
            heightProportion,
            widthProportion: nodewidth || 1200,
        });
    }

    addHandleReport(rowid, studentName){
        this.setState({ studentName });
        this.props.fetchInjuryAllProfile(rowid).then((data) => { 
               
                this.setState({ 
                    viewdiv:false,
                    errordiv:false,
                    succdiv:true 
                });

                setTimeout(() => {
                    this.updateDimensions();
                  }, 1000);
               
        });

        
        
    }

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	}


    exportPDFWithMethod = () => {
        const { injuryallprofile } = this.props;
        const studentName = this.state.studentName || (injuryallprofile[0] && injuryallprofile[0].injurydetails && injuryallprofile[0].injurydetails.student) || '';
        const pdfFileName = `${studentName} - Injury Profile`;

        if (this.nodeRef.current) {
            savePDF(this.nodeRef.current, {
                paperSize: 'A4',
                margin: { top: '2.2cm', left: '1.5cm', right: '1.5cm', bottom: '1.5cm' },
                scale: 0.6,
                fileName: pdfFileName,
                pageTemplate: PageTemplate,
            });
        }
    }

    onBackSection() {
		this.setState({ 
            succdiv:false,
            viewdiv:true,
         });
	}

    render() {
       const { match, injuryprofilelist, injuryallprofile, loading } = this.props;

       const rows = injuryallprofile.reduce(function (rows, key, index) { 
            return (index % 2 == 0 ? rows.push([key]) 
            : rows[rows.length-1].push(key)) && rows;
        }, []);  
        
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "report", label: "Report" }
        ];
        const tabledata=injuryprofilelist.map((assmntval,idx) => {            
            
            const ebtn=<MatButton variant="contained" className="btn-icon btn-google mr-15 mb-10 text-white" onClick={ ()=>this.addHandleReport(assmntval.userID, assmntval.student)}> <i className="zmdi zmdi-file-text"></i> Profile</MatButton>;
             
                return {
                no:idx+1,
                name: assmntval.student,
                report: ebtn
                }
        });

        const styles = {
            table: {
                border: "1px solid black",
                borderColor:"black",
                borderStyle:"solid",
                fontFamily: "Arial",            
                zIndex:"100"
            },
            tablelefthead:{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                width:"30%",
                fontWeight:"bold",
                fontSize:"18px"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                fontSize:"16px"
            },
            rctcontent:{
            
                borderRadius: "5px",
                boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
                border: "none",
                transition: "all 0.4s ease-in-out 0s",
                marginBottom: "24px",
                position: "relative"
    
            }
        };

        const settings = {
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false
		};
        const uptcnt=rows.length;
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Injury Profile Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.injuryprofilereportheading" />} match={match} />

                {this.state.viewdiv && 
                    <div className="row">
                        <div className="col-sm-12 col-md-8">
                            <RctCollapsibleCard heading="Injury Profile List" fullBlock>
                                <MUIDataTable                              
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                                />   
                            </RctCollapsibleCard>
                        </div>                     
                    </div>  
                } 

                {this.state.succdiv &&                   
                    <div className="row">
                         <div className="col-sm-12 col-md-12">
                            <div className="float-right">
                            <button
                            className="mr-3 mb-3 btn btn-outline-primary"
                            onClick={this.exportPDFWithMethod}
                            >
                            Export PDF
                            </button>
                            <button
                            className="mr-3 mb-3 btn btn-outline-warning"
                            onClick={this.onBackSection}
                            >
                            Back
                            </button> 
                            </div>                       
                        </div>
                        <div className="col-sm-12 col-md-12" style={{ width: '100%' }}>
                        <CarouselProvider                            
                            naturalSlideWidth={this.state.widthProportion}
                            naturalSlideHeight={this.state.heightProportion}
                            totalSlides={uptcnt}
                            isIntrinsicHeight={true}
                            >
                          <div className="sdfsdf" style={{padding:"20px"}}>
                            <ButtonBack className="mr-3 mb-3 btn btn-outline-primary">Prev</ButtonBack>
                            <ButtonNext className="mr-3 mb-3 btn btn-outline-primary float-right">Next</ButtonNext>
                            <div className="text-center" style={{marginTop:"-30px"}}>
                                {rows.map((uptval,key) => ( 
                                    <Dot className="text-center" slide={key} >{key+1}</Dot>
                                ))}
                            </div>                        
                        </div>
                        <div ref={this.nodeRef} style={{ width: '100%' }}>
                        <RctCollapsibleCard fullBlock>
                         <Slider> 
                        {rows.map((row, key) => (
                            <Slide index={key}>
                             <div key={key} className="testclass">
                        {row.map(({injurydetails, injuryupdates, injuryreports}) => (
                           
                          
                            <div className="col-sm-12 col-md-12" style={{display:"inline-block", width:"100%"}}>                             
                                    <div style={styles.rctcontent}>
                                        <div className="collapse show">
                                            <div className="rct-block-content">
                                                <div className="row justify-content-center reportdiv">
                                                    <h1 className="text-center"> Injury Chart</h1>
                                                    <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                        <tbody>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Name 
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.student}
                                                            </td>                                                   
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Date and Time
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                            {Moment(injurydetails.sic_date).format('DD/MM/YYYY   hh:mm a')}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Age / Gender
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_age} / {injurydetails.sic_gender==1?'Male':'Female'}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Skill
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_skill}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Chief Complaint
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_chief_complaint}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Mechanism Of Injury
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_mechanism_injury}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            History of Present Injury
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_history_present_injury}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            History of Similar Injury in the Past
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_history_injury_past}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                                Clinical Assessment and Observations
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_observations_assessment}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Clinical Findings
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_clinical_findings}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Provisional Diagnosis
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_provisional_diagnosis}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Injury Severity
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_injury_severity}
                                                            </td>
                                                        </tr>                                                
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Plan Of Action
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_plan_action}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Medical Tests/Reports (if any)
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injuryreports.length==0 ? "No":"Uploaded"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Expected time for Return to Sports
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_return_sports}
                                                            </td>
                                                        </tr>                                                
                                                        <tr>
                                                            <td style={styles.tablelefthead}>
                                                            Notes for Coaching Team
                                                            </td>
                                                            <td style={styles.tabletrtd}>
                                                                {injurydetails.sic_coaching_team}
                                                            </td>
                                                        </tr>                                                
                                                        </tbody>
                                                    </table>
                                                    <div className="col-md-12" style={{marginTop:"80px"}}>
                                                        <p style={{fontSize:"20px"}}>{injurydetails.sc_name}</p>
                                                        <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{injurydetails.sc_designation}</p>
                                                        <p style={{marginTop:"20px",fontSize:"20px", fontWeight:"300"}}>{'{e}'} {injurydetails.sc_email}</p>
                                                        <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {injurydetails.sc_phone}</p>
                                                    </div>     
                                                    {injuryreports.length!=0 ?(
                                                    <div className="col-md-12">
                                                        <h1 style={{marginTop:"30px", marginBottom:"20px"}}> Medical Reports</h1>
                                                        {injuryreports.map((filval,idx) => (  
                                                        <p><a style={{color:"red"}} href={AppConfig.apiurl+'/theme/img/injuryreport/'+filval.sir_filename} target="_blank">{idx+1}.{filval.sir_reportname}</a></p>
                                                        ))}   
                                                    </div>  ):(" ")
                                                    } 
                                                    {injuryupdates.map((uptval,idx) => (  
                                                        <div className="col-md-12">
                                                            <h1 className="text-center" style={{marginTop:"30px", marginBottom:"20px"}}> Injury Update</h1>   

                                                            <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                                <tbody>
                                                                    
                                                                    <tr>
                                                                        <td style={styles.tablelefthead}>
                                                                            Date and Time
                                                                        </td>
                                                                        <td style={styles.tabletrtd}>
                                                                        {Moment(uptval.siu_date).format('DD/MM/YYYY   hh:mm a')} 
                                                                        </td>
                                                                    </tr>                                                            
                                                                    <tr>
                                                                        <td style={styles.tablelefthead}>
                                                                        Update on Rehabilitation
                                                                        </td>
                                                                        <td style={styles.tabletrtd}>
                                                                            {uptval.siu_update_rehabilitation}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={styles.tablelefthead}>
                                                                        Plan Of Action
                                                                        </td>
                                                                        <td style={styles.tabletrtd}>
                                                                            {uptval.siu_plan_action}
                                                                        </td>
                                                                    </tr>                                                                                                          
                                                                </tbody>
                                                            </table>
                                                            <div className="col-md-12" style={{marginTop:"20px"}}>
                                                                <p style={{fontSize:"20px"}}>{uptval.sc_name}</p>
                                                                <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{uptval.sc_designation}</p>
                                                                <p style={{fontSize:"20px", fontWeight:"300"}}>{'{e}'} {uptval.sc_email}</p>
                                                                <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {uptval.sc_phone}</p>
                                                            </div> 
                                                        </div>
                                                    ))}                                    
                                                </div>
                                            </div>
                                        </div>        
                                    </div> 
                                
                            </div>
                             
                            ))}

                            </div>
                            </Slide>
                        ))} 

                        </Slider>
                        </RctCollapsibleCard>
                        </div>
                        </CarouselProvider>
                      </div>
                    </div>
                }     
               
            
          </div>
       )
    }
 }

const mapStateToProps = ({injurychart  }) => {
   
    const { injuryprofilelist, injuryallprofile,  loading } = injurychart;
	return { injuryprofilelist, injuryallprofile, loading };
}

export default connect(mapStateToProps, {
    allInjuryprofile,
    fetchInjuryAllProfile
})(injuryprofilereport); 